// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Request from '../../../api/Request';
import { observable } from 'mobx';
import { Redirect } from 'react-router';
import CommentSection from './CommentSection/CommentSection';
import Card from './Card/Card';
import Subscriber from '../../../api/Subscriber';

@inject('userStore')
@observer class Container extends Component<any, any> {

	@observable match: any;

	@observable failed: boolean = false;

	@observable receivedComments: any = {};

	subscriber = new Subscriber();

	constructor(props: any) {
		super(props);

		this.handleCreateSubscriberMessage = this.handleCreateSubscriberMessage.bind(this);
	}

	componentDidMount() {
		Request.get('/matches/' + this.props.id, {}).then((response) => {
			if(!response.status) {
				this.match = response;

				this.subscriber.addTopic(
					'/matches/' + this.match.id + '/comments',
					'create_match_comment_' + this.match.id,
					this.handleCreateSubscriberMessage
				);

				this.subscriber.subscribe();
			} else {
				this.failed = true;
			}
		});
	}

	componentWillUnmount() {
		this.subscriber.unsubscribe();
	}

	handleCreateSubscriberMessage(response: any) {
		const comment = response['@comment'];
		if(response['@action'] === 'post') {
			this.receivedComments[this.getIndexFromUsedId(comment.user.id, this.match)] = comment;
		}
	}

	getIndexFromUsedId(id: number, match: any): number {
		for(let user in match.participants) {
			if(match.participants[user].id === id) {
				return parseInt(user);
			}
		}

		return -1;
	}

	center() {
		const element = document.querySelector('.match');
		const commentSection = document.querySelector('.comment-section');
		if(element && commentSection) {
			// 135 = headerHeight(60) + marginCommentSectionTop(50) + marginCommentBottom(25)
			const toScroll = ((commentSection.clientHeight + 135) + element.clientHeight/2) - (window.innerHeight / 2);
			window.scrollTo(0, toScroll);
		}
	}

	render() {
		if(!this.failed) {
			return (
				<div className="match-container">
					{this.match ? 
						<CommentSection 
							center={this.center} 
							match={this.match} 
							order={0}
							receivedComment={this.receivedComments[0] ? this.receivedComments[0] : null} 
							user={this.match.participants[0]}/>
						:
						null
					}
					<Card match={this.match}/>
					{this.match ? 
						<CommentSection 
							center={this.center} 
							match={this.match} 
							order={1}
							receivedComment={this.receivedComments[1] ? this.receivedComments[1] : null} 
							user={this.match.participants[1]}/>
						:
						null
					}
				</div>
			)
		} else {
			return (
				<Redirect to="/" />
			)
		}

	}
}

export default Container;

